import { render, staticRenderFns } from "./MtCompanies.vue?vue&type=template&id=42337f2a&"
import script from "./MtCompanies.vue?vue&type=script&lang=js&"
export * from "./MtCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports